import React, { Suspense, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { WhastsappButton, ScrollToTop, Spinner, PopupAd } from '../components';
import LandingStack from '../Routers/LandingStack';
import { isV2AuthRoute, isLegacyPublicRoute, NavBarV2, FooterV2, V2Root } from '../Routers/landingScreens';


const LandingLayout = () => {

    const { inAuthLayout } = useSelector(state => state.configs);
    const { pathname } = useLocation();

    useEffect(() => {
        if (!inAuthLayout) {
            const element1 = document.getElementById('gtagscirpt1');
            if (element1) {
                element1.remove();
            }

            const element2 = document.getElementById('gtagscirpt2');
            if (element2) {
                element2.remove();
            }

            // Create the script element
            var script = document.createElement('script');
            script.async = true;
            script.src = 'https://www.googletagmanager.com/gtag/js?id=G-F97DB3GKK9';
            script.setAttribute("id", "gtagscirpt1");

            // Append the script element to the document head
            document.head.appendChild(script);

            // Create the inline script element
            var inlineScript = document.createElement('script');

            inlineScript.setAttribute("id", "gtagscirpt2");
            inlineScript.innerHTML = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'G-F97DB3GKK9');
            `;

            // Append the inline script element to the document head
            document.head.appendChild(inlineScript);
        }

    });

    // The auth screens: bare, with no header or footer, but still wrapped in
    // `V2Root` — which is what carries `dir`, `lang`, the Tajawal face and the
    // module's own stylesheet. Without it the global `rtl.css` wins on the bare
    // `div` selector and the screen comes up in Cairo, laid out the wrong way
    // round.
    //
    // Decided from the path rather than from `inAuthLayout`, even though those
    // pages raise that flag too. The flag is set in an effect, so for one paint
    // it is still false and the branch below would render a header that then
    // disappears.
    //
    // `!` on the ground because `base.css` paints `.v2-root` the landing's warm
    // colour and the auth screens are white; both selectors score the same, so
    // otherwise it would come down to the order webpack injects two stylesheets.
    if (isV2AuthRoute(pathname)) {
        return (
            <V2Root className="!tw-bg-white">
                <Suspense fallback={<Spinner />}>
                    <LandingStack />
                </Suspense>
            </V2Root>
        );
    }

    // The badge and attendance-certificate pages, which have no new design.
    // Only the header and the footer are wrapped: `base.css` resets font and
    // direction on everything inside `.v2-root`, and would reflow the page's
    // semantic-ui layout. The header's root is what sticks, as in
    // `StudentLayout`.
    if (isLegacyPublicRoute(pathname)) {
        return (
            <>
                <ScrollToTop />
                <V2Root smoothScroll={false} className="tw-sticky tw-top-0 tw-z-40 !tw-min-h-0">
                    <NavBarV2 />
                </V2Root>
                <Suspense fallback={<Spinner />}>
                    <LandingStack />
                </Suspense>
                <V2Root smoothScroll={false} className="!tw-min-h-0">
                    <FooterV2 />
                </V2Root>
                <WhastsappButton showSidebar={null} />
            </>
        );
    }

    return (
        <V2Root>
            <ScrollToTop />
            <NavBarV2 />
            <Suspense fallback={<Spinner />}>
                <LandingStack />
            </Suspense>
            <FooterV2 />
            <WhastsappButton showSidebar={null} />
            <PopupAd isLanding={true} />
        </V2Root>
    );
};

export default LandingLayout;
